/**
 * multiselect เก็บค่า option.value ซึ่งตรงกับ warrantyMobileId ของแต่ละรายการจาก API
 * ปั้นเป็น warrantyMobileIds — array ของ warrantyMobileId เท่านั้น
 */
const buildWarrantyMobileIdsPayload = (raw) => {
  if (raw == null) {
    return [];
  }
  const list = Array.isArray(raw) ? raw : [raw];
  return list
    .map((entry) => {
      if (entry == null) {
        return null;
      }
      if (typeof entry === 'object' && entry.warrantyMobileId != null) {
        return entry.warrantyMobileId;
      }
      if (typeof entry === 'object' && 'value' in entry) {
        return entry.value;
      }
      return entry;
    })
    .filter((id) => id != null);
};

export const handleSubmitForm = (values, onAddClaim) => {
  const warrantyMobileIds = buildWarrantyMobileIdsPayload(values.warrantyMobileIds);
  const hasOther = warrantyMobileIds.some((id) => id == -1);
  const uploadData = {
    claimImage: values.claimImage ? values.claimImage[0] : null,
    receiptImage: values.receiptImage ? values.receiptImage[0] : null,
    warrantyId: values.warrantyId,
    warrantyMobileIds,
    warrantyMobileOtherReason: hasOther ? values.warrantyMobileOtherReason : undefined,
    customerCode: values.customerCode,
    detail1: values.detail1,
    detail2: values.detail2,
    breakdownId: values.breakdownId,
    breakdownSubId: values.breakdownSubId,
    addressLine1: values.addressLine1,
    addressLine2: values.addressLine2,
    subDistrictId: values.subDistrictId,
    zipcode: values.zipcode,
    other: values.other,
    isCreateNewAddress: values.isCreateNewAddress,
  };

  onAddClaim(uploadData);
};
